import { OfferBuyAllDetails, OfferTag } from "@/graphql";

export enum OfferStatus {
  Draft = "DRAFT",
  Pending = "PENDING",
  Published = "PUBLISHED",
  Terminating = "TERMINATING",
  Stopped = "STOPPED",
}

export interface OfferCondition {
  activeDays?: string[];
  activeStartTime?: string;
  activeEndTime?: string;
  coolDown?: null | object;
  dailyLimit?: number;
  rewardMultiplier?: number;
  skipFrequency?: number;
  segments?: string[];
}

interface IAPDetails {
  id: string;
  productId?: string;
  price?: number;
  currency?: string;
}

export interface Offer {
  id: string;
  name: string;
  technicalName: string;
  displayCountDown: boolean;
  status: OfferStatus;
  startDate: string;
  endDate: string;
  trigger: string;
  conditions: OfferCondition;
  androidIAP: IAPDetails;
  iosIAP: IAPDetails;
}

interface IapInput {
  id: string;
}

enum OfferTimerType {
  Absolute = "ABSOLUTE",
  Relative = "RELATIVE",
}

export interface OfferUpdateInput {
  name?: string;
  triggers?: string[];
  timer?: {
    timerType: OfferTimerType;
    timerDuration?: string;
  };
  status?: OfferStatus | null;
  displayCountDown?: boolean;
  androidIAP?: IapInput | null;
  iosIAP?: IapInput | null;
  conditions?: Partial<OfferCondition>;
  isEndless?: boolean | null;
  isChained?: boolean | null;
  campaignId?: string | null;
  offerBuyAllDetails?: OfferBuyAllDetails | null;
  abtestLinkMode?: "INCLUDE" | "EXCLUDE" | null;
}

export interface OfferItem {
  id: string;
  name?: string;
  createdAt?: string;
  updatedAt?: string;
  startDate?: string;
  endDate?: string;
  status: OfferStatus;
  technicalName?: string;
  title?: string;
  highlightTexts?: string[];
  tags?: OfferTag[];
  campaignId: string;
  offerBuyAllDetails: OfferBuyAllDetails | null;
}

export type Campaign = {
  id: string;
  name: string;
  offers: OfferItem[] | undefined;
  purchaseLimit: number | null;
};

export type CampaignOption = {
  value: string;
  name: string;
};

export type CampaignInput = {
  id?: string;
  name: string;
  purchaseLimit?: number;
};

export type CampaignSelection = CampaignOption & {
  selected: boolean;
};
